import * as THREE from 'three';

/**
 * ジオメトリデータを収集し、ワールド座標をローカル座標に変換
 * Blenderで作成したモデルを物理演算で使用するための処理
 * @param root
 * @returns
 */
export const transformToLocalGeometry = (root: THREE.Object3D): {
  vertices: Float32Array,
  indices: Uint32Array,
  origin: THREE.Vector3,
  rotation: THREE.Quaternion
} | null => {
  const vertices: number[] = [];
  const indices: number[] = [];
  let vertexOffset = 0;

  root.updateWorldMatrix(true, true); // 最新World座標を取得
  const origin = new THREE.Vector3();
  const rotation = new THREE.Quaternion();
  const scale = new THREE.Vector3();
  root.matrixWorld.decompose(origin, rotation, scale); // rootの位置・回転・スケールを取得
  const inverseRotation = rotation.clone().invert(); // rootの“ワールド回転”を打ち消す回転
  const tempVertex = new THREE.Vector3();

  root.traverse((child) => {
    if (!(child instanceof THREE.Mesh)) return;
    const mesh = child as THREE.Mesh;
    const originalGeometry = mesh.geometry;
    if (!originalGeometry) return;

    const geometry = originalGeometry.clone();
    geometry.applyMatrix4(mesh.matrixWorld);

    const positionAttr = geometry.getAttribute('position'); // Geometryの位置情報を取得
    const indexAttr = geometry.getIndex();
    if (!positionAttr) return;

    for (let i = 0; i < positionAttr.count; i++) {
      tempVertex.set(positionAttr.getX(i), positionAttr.getY(i), positionAttr.getZ(i));
      tempVertex.sub(origin); // 頂点から原点を引いて、座標を相対的な位置に変換
      tempVertex.applyQuaternion(inverseRotation); //「逆回転」を適用して、オブジェクトの回転を打ち消す
      vertices.push(tempVertex.x, tempVertex.y, tempVertex.z);
    }

    if (indexAttr) {
      for (let i = 0; i < indexAttr.count; i++) {
        indices.push(indexAttr.getX(i) + vertexOffset);
      }
    } else {
      for (let i = 0; i < positionAttr.count; i += 3) {
        indices.push(vertexOffset + i, vertexOffset + i + 1, vertexOffset + i + 2);
      }
    }

    vertexOffset += positionAttr.count;
  });

  if (vertices.length === 0 || indices.length === 0) {
    return null;
  }

  return {
    vertices: new Float32Array(vertices),
    indices: new Uint32Array(indices),
    origin,
    rotation,
  };
}